<template>
<b-container fluid class="container">
   <b-row class="justify-content-md-center">
          <b-col col md="3" class="text-center">
           <Descripcion/>
            <div class="mb-5" >
                  <img src="../assets/wizard2.png" class="img-fluid" alt="" />
            </div>
            <hr>
            <div class="mb-5">
              <h6>Estamos para ayudarte</h6>
              <p style="font-size: 15px">¿Deseas ser asistido por uno de nuestros asesores?</p>
                  <b-button @click.prevent="" variant="outline-primary" class="button_H11">ESTAMOS PARA AYUDARTE</b-button>
            </div>
          </b-col>
          <b-col  col md="9" class="card-body text-center">
            <Sesion/>
            <h1 class="mt-5">INFORMACIÓN PERSONAL</h1>
            <p>Completa tu información y completa tu usuario.</p>
            <p>Al completar este formulario podremos ofrecerte un servicio más completo.</p>

            <b-card border-variant="light" class="mt-3">
            <b-form @submit="onSubmit" @reset="onReset" v-if="show">
            <b-row >
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-1"  class="text-left" label-for="input-1">
                        <h6>* Fecha de Nacimiento</h6>
                    <b-form-input id="input-1" type="text" class="inputFormulario" placeholder="Ingrese aquí" onkeypress="return (event.charCode == 32 || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122))" maxlength="26" required></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-2" class="text-left" label-for="input-3">
                        <h6>* Regimen fiscal</h6>
                    <b-form-input id="input-2" class="inputFormulario" placeholder="Ingrese aquí" onkeypress="return (event.charCode == 32 || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122))" maxlength="26" required></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-3"  class="text-left" label-for="input-3">
                        <h6>* RFC</h6>
                    <b-form-input id="input-3" class="inputFormulario" placeholder="Ingrese aquí" onkeypress="return (event.charCode == 32 || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122))" maxlength="26" required ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
            </b-row>
            <hr>

            <b-row >
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-1"  class="text-left" label-for="input-1">
                        <h6>Nombre(s)</h6>
                    <b-form-input id="input-1" type="text" class="inputFormulario" v-model="formaData.Nombre" placeholder="Nombre(s)" onkeypress="return (event.charCode == 32 || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122))" maxlength="26" required></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-2" class="text-left" label-for="input-3">
                        <h6>Primer Apellido</h6>
                    <b-form-input id="input-2" class="inputFormulario" v-model="formaData.ApellidoPaterno" placeholder="Primer Apellido" onkeypress="return (event.charCode == 32 || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122))" maxlength="26" required></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-3"  class="text-left" label-for="input-3">
                        <h6>Segundo Apellido</h6>
                    <b-form-input id="input-3" class="inputFormulario" v-model="formaData.ApellidoMaterno" placeholder="Segundo Apellido" onkeypress="return (event.charCode == 32 || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122))" maxlength="26" required ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
            </b-row>
            <b-row class="mt-2">
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-3"  class="text-left" label-for="input-3">
                        <h6>* Nacionalidad</h6>
                    <b-form-input id="input-3" class="inputFormulario" v-model="formaData.interes" placeholder="" onkeypress="return (event.charCode == 32 || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122))" maxlength="26" required ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-5" label-for="input-5" class="text-left">
                        <h6>* Correo electrónico</h6>
                        <b-form-input id="input-5"  v-model="formaData.email" type="email" placeholder="Ingresa tu email" required ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-6" class="text-left" label-for="input-6">
                        <h6>* Celular</h6>
                    <b-form-input id="input-6" class="inputFormulario" v-model="formaData.PhoneNumber" type="text" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57" placeholder="Número de Teléfono" maxlength="10" required ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
            </b-row>

            <b-row class="mt-5">
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-7" class="text-left" label-for="input-7">
                        <h6>Código Postal:</h6>
                    <b-form-input id="input-7" class="inputFormulario" v-model="formaData.CodigoPostal" placeholder="Código Postal" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57" maxlength="5" required ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-8" label-for="input-8" class="text-left">
                        <h6>Estado:</h6>
                        <b-form-input id="input-8" class="inputFormulario" v-model="formaData.estado" placeholder="Estado" onkeypress="return (event.charCode == 32 || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122))" maxlength="40" required ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>

                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-9" class="text-left" label-for="input-9">
                        <h6>Ciudad:</h6>
                    <b-form-input id="input-9" class="inputFormulario" v-model="formaData.CiudadNacimiento" placeholder="Ciudad" onkeypress="return (event.charCode == 32 || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122))" maxlength="40" required ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
            </b-row>

            <b-row>
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-16" class="text-left" label-for="input-16">
                        <h6>Colonia o Población:</h6>
                    <b-form-input id="input-16" class="inputFormulario" v-model="formaData.Colonia" placeholder="Colonia" onkeypress="return (event.charCode == 32 || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122))" maxlength="40" required ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-17" class="text-left" label-for="input-17">
                        <h6>Delegación o Municipio:</h6>
                    <b-form-input id="input-17" class="inputFormulario" v-model="formaData.delegacion" placeholder="Delegación" onkeypress="return (event.charCode == 32 || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122))" maxlength="40" required ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-13" class="text-left" label-for="input-13">
                        <h6>Calle:</h6>
                    <b-form-input id="input-13" class="inputFormulario" v-model="formaData.Calle" placeholder="Calle" onkeypress="return (event.charCode == 32 || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122))" maxlength="40" required ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
            </b-row>
            <b-row class="mt-2">
            <div class="col-md-3">
                <b-col>
                    <b-form-group id="input-group-14" label-for="input-14" class="text-left">
                        <h6>Número Exterior:</h6>
                        <b-form-input id="input-14" class="inputFormulario" v-model="formaData.NumeroExterior" type="text" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57" maxlength="5" placeholder="Exterior" required></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
                <div class="col-md-3">
                <b-col>
                    <b-form-group id="input-group-15" class="text-left" label-for="input-15">
                        <h6>Número Interior:</h6>
                    <b-form-input id="input-15" class="inputFormulario" v-model="formaData.NumeroInterior" type="text" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57" maxlength="5" placeholder="Interior"  ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
            </b-row>
            <b-row class="mt-5">
                <div class="col-md-12">
                <b-col>
                  <b-button @click.prevent="actualiza()" variant="primary" class="button_H">ACTUALIZAR DATOS</b-button>
                </b-col>
                </div>
            </b-row>
      <b-row align-h="center" >
        <div class="col-md-9">
        <b-col>        
          <b-form-checkbox id="checkbox-2" v-model="terminos" name="checkbox-2" value="accepted" unchecked-value="not_accepted">
            <a href="https://www.autocom.mx/formato-derechos-arco.html" target="_blank" >Términos y condiciones</a>
          </b-form-checkbox>
        </b-col>
        </div>
      </b-row>
      <b-row align-h="center" >
        <div class="col-md-9">
        <b-col>          
          <b-form-checkbox id="checkbox-1" v-model="privacidad" name="checkbox-1" value="accepted" unchecked-value="not_accepted">
            <a href="https://www.autocom.mx/aviso-de-privacidad.html" target="_blank" >Aviso de privacidad</a>
          </b-form-checkbox>
        </b-col>
        </div>        
      </b-row>

            <div><p class="aviso mt-3">En cumplimiento a lo previsto en la Ley General de Protección de Datos Personales en Posesión de Sujetos Obligados, nos permitimos informarle lo siguiente:
                Nissan Autocom Morelia Madero, en lo sucesivo ("Nissan Autocom Morelia Madero"), con domicilio en Av. Madero Pte. 1613 Col. Gertrudis Bocanegra., Morelia, Michoacán de Ocampo, Mexico 58150, es responsable de recabar sus datos personales, del tratamiento que se les da a los mismos y de su adecuada protección, para sí o para cualquiera de las sociedades mercantiles que sean sus subsidiarias o filiales.</p></div>
            </b-form>
        </b-card>

          </b-col>
    </b-row>
</b-container>
</template>

<script>
import Sesion from './Sesion.vue'
import Descripcion from './Descripcion.vue';

export default {
  name: 'Registro',

  components: {
    Sesion,
    Descripcion
  },

    data() {
    return {


      contents: null,
      autos: [],
      photos: '',
      privacidad: 'not_accepted',
      terminos: 'not_accepted',
          formaData: {
            Nombre: '',
            ApellidoPaterno: '',
            ApellidoMaterno: '',
            Email: '',
            Telefono: '',
            interes: 'Financiamiento',
            CodigoPostal: '',
            Ciudad: '',
            Estado: '',
            FechaNacimiento: '',
            RegimenFiscal: '',
            RFC: '',
            Calle: '',
            NumExterior: '',
            NumInterior: '',
            Colonia: '',
            Delegacion: ''
          },
        show: true,
        regimen: [
          { value: 1, text: 'Persona Física' },
          { value: 2, text: 'Persona Física con Actividad Empresarial' }
        ],

      };
  },

  methods: {
        onSubmit(event) {
            event.preventDefault();
        },

        onReset(event) {
            window.history.go(-2);
        },

        reserva(){
          this.$router.push({ path: '/Bienvenido'});
        },

    formatPrice(value) {
        let val = (value/1).toFixed(0).replace('.', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },

    formatPriceCostos(value) {
        let val = (value/1).toFixed(2).replace('.', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
  },
  
  created() {

  },

     computed: {
      validaRfc() {
        return this.formaData.AditionalInfo.RFC.length < 14 && this.formaData.AditionalInfo.RFC.length > 12 && this.formaData.AditionalInfo.RFC.length != '' ? true: false
      },

      validaTel() {
        return this.formaData.PhoneNumber.length < 11 && this.formaData.PhoneNumber.length > 9 && this.formaData.PhoneNumber.length != '' ? true: false
      },

      validaCp() {
        return this.formaData.CodigoPostal.length < 6 && this.formaData.CodigoPostal.length > 4 && this.formaData.CodigoPostal.length != '' ? true: false
      },

      validaNombre() {
        return this.formaData.Nombre.length < 27 && this.formaData.Nombre.length > 0 && this.formaData.Nombre.length != '' ? true: false
      },

      validaApaterno() {
        return this.formaData.ApellidoPaterno.length < 27 && this.formaData.ApellidoPaterno.length > 0 && this.formaData.ApellidoPaterno.length != '' ? true: false
      },

      validaAmaterno() {
        return this.formaData.ApellidoMaterno.length < 27 && this.formaData.ApellidoMaterno.length > 0 && this.formaData.ApellidoMaterno.length != '' ? true: false
      },

      validaCalle() {
        return this.formaData.AditionalInfo.Calle.length < 41 && this.formaData.AditionalInfo.Calle.length > 0 && this.formaData.AditionalInfo.Calle.length != '' ? true: false
      },
      validaEstado() {
        return this.form.estado.length < 41 && this.form.estado.length > 0 && this.form.estado.length != '' ? true: false
      },
      validaCiudad() {
        return this.formaData.CiudadNacimiento.length < 41 && this.formaData.CiudadNacimiento.length > 0 && this.formaData.CiudadNacimiento.length != '' ? true: false
      },
      validaDelegacion() {
        return this.form.delegacion.length < 41 && this.form.delegacion.length > 0 && this.form.delegacion.length != '' ? true: false
      },
      validaColonia() {
        return this.formaData.AditionalInfo.Colonia.length < 41 && this.formaData.AditionalInfo.Colonia.length > 0  && this.formaData.AditionalInfo.Colonia.length != '' ? true: false
      },
    }
}
</script>

<style scoped>


</style>